import { useState } from "react";
import axios from "axios";

import Controls from "./components/Controls";
import Results from "./components/Results";
import Chart from "./components/Chart";
import Loading from "./components/Loading";

function App() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const analyzeMarket = async (market, period) => {
        setLoading(true);

        try {
            const response = await axios.get(
                `https://market-regime-backend-tw6d.onrender.com/analyze?market=${market}&period=${period}`
                // `http://127.0.0.1:8000/analyze?market=${market}&period=${period}`    // for local development
            );

            setData(response.data);
        } catch (error) {
            console.error("API error:", error);
        }

        setLoading(false);
    };

    return (
        <div className="app-container">
            <header className="app-header">
                <h1>Market Regime Analyzer</h1>
                <p className="subtitle">
                    Understand market conditions using trend, momentum, and volatility signals
                </p>
            </header>
            <Controls onAnalyze={analyzeMarket} loading={loading} />

            {loading ? (
                <Loading />
            ) : (
                <>
                    <Results data={data} />
                    <Chart chart={data?.chart} />
                </>
            )}

            <footer className="footer">
                <p className="footer-line">
                    Market Regime Analyzer · © 2026
                </p>
                <p className="footer-subline">
                    Educational use only · Not financial advice
                </p>
            </footer>
        </div>
    );
}

export default App;